import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Customer } from '@inyova/models';
import { NgxZendeskWebwidgetService } from 'ngx-zendesk-webwidget';

import { Store } from '@ngrx/store';
import * as ProfileActions from '@profile/profile.actions';

import { LanguageList, LanguageService } from '@shared/services/language.service';

@Component({
  selector: 'app-profile-change-language',
  templateUrl: './profile-change-language.component.html',
  styleUrls: ['./profile-change-language.component.scss'],
  standalone: false
})
export class ProfileChangeLanguageComponent implements OnChanges {
  @Input() customer: Partial<Customer>;
  formLang: FormGroup;
  languages: LanguageList;

  constructor(
    private formBuilder: FormBuilder,
    private store: Store,
    private zendeskService: NgxZendeskWebwidgetService,
    private languageService: LanguageService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customer) {
      this.customer = changes.customer.currentValue;

      this.formLang = this.formBuilder.group({
        language: [this.customer.language]
      });
      this.languages = this.languageService.getListOfLanguages(this.customer.app_location);

      // TODO: 20.02.2026 Temporary disabled till we figure out the problem with the script
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      // this.zendeskService.zE.setLocale(this.customer.language.slice(0, 2));
    }
  }

  changeLanguage(): void {
    const { language } = this.formLang.value;
    if (language === this.customer.language) {
      return;
    }

    this.store.dispatch(ProfileActions.updateCustomerLanguage({ personalDetails: { language } }));
  }
}
